import { RetailerApiClient } from '@/services/RetailerApiClient.js'

export default {
  getBankAccounts() {
    return RetailerApiClient.get('/bank-accounts').then(response => response)
  },
  getTarfinProBankAccounts() {
    return RetailerApiClient.get('/bank-accounts/get-tarfin-pro-bank-accounts')
  }
}
